import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HighchartOptionsService } from '../../../reporting/services/highchart-options.service';
import * as Highcharts from 'highcharts';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ExportFilenameService } from '../../../../shared/services/export-filename.service';

@Component({
  selector: 'app-sim-data-graph',
  template: require('./sim-data-graph.component.html'),
  styles: [require('./sim-data-graph.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimDataGraphComponent implements OnInit, OnDestroy {

  @Input() data: any[]
  @Input() from: string;
  @Input() to: string;
  @Input() limit: number; 
  @Output() updatePeriod = new EventEmitter<{
    from: Date,
    to: Date
  }>();

  Highcharts: typeof Highcharts = Highcharts;
  simChartOptions: Highcharts.Options;
  languageChangeSubscription: Subscription;

  yearRange: string;
  selectedMonth: any;
  maxDateTime = new Date();

  constructor(
    private highchartOptionsService: HighchartOptionsService,
    private translate: TranslateService
  ) {
    
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this._processChartData();
    })
  }

  ngOnInit(): void {
    this.selectedMonth = new Date(Date.parse(this.from));
    const maxYear = new Date().getFullYear();
    const minYear = maxYear - 5;
    this.yearRange = `${minYear}:${maxYear}`;
    this._processChartData();
  }

  _processChartData = () => {
    this.data = this.data.map(point => {
      return {
        ...point,
        limit: this.limit
      }
    });
    const graphFilename = ExportFilenameService.generate('SIM-Card-Overview-Details')
    this.simChartOptions = this.highchartOptionsService.simDataPeriodChart(graphFilename, this.data);
  }

  onUpdatePeriod(selectedMonth: Date) {
    const from = new Date(selectedMonth);
    this.updatePeriod.emit({
      from: from,
      to: new Date(from.getFullYear(), from.getMonth()+1, 0)
    })
  }

  selectRelativeMonth(monthDifference: number) {
    const previousMonth = new Date(this.selectedMonth);
    previousMonth.setDate(1);
    previousMonth.setMonth(previousMonth.getMonth() + monthDifference);
    this.onUpdatePeriod(previousMonth)
  }
  
  ngOnDestroy() {
    this.languageChangeSubscription.unsubscribe();
  }

  isCurrentMonth() {
    return (this.selectedMonth.getMonth() === this.maxDateTime.getMonth()) && 
      (this.selectedMonth.getFullYear() === this.maxDateTime.getFullYear())
  }
}
